import React, {Component} from 'react'
import { browserHistory } from 'react-router'
import * as firebase from 'firebase'

const Jeyu = {
  banner: {
    background: '#333',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  form: {
    display: 'flex',
    flexDirection: 'column'
  },
  labelBox: {
    margin: '10px 0'
  },
  label: {
    display: 'block'
  },
  input: {
    width: '100%',
    height: 45
  },
  btn: {
    background: '#ffab12',
    color: '#333',
    height: 50,
    border: 'none',
    margin: '25px 0',
    fontSize: 20
  }
}

export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: ''
    }
    this.handleChangeEmail = this.handleChangeEmail.bind(this)
    this.handleChangePassword = this.handleChangePassword.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  componentDidMount () {
    window.scrollTo(0, 0)
  }
  componentWillUnmount() {
    window.scrollTo(0, 0)
  }
  handleChangeEmail(event) {
    this.setState({
      email: event.target.value
    })
  }

  handleChangePassword(event) {
    this.setState({
      password: event.target.value
    })
  }

  handleSubmit(event) {
    firebase.auth().signInWithEmailAndPassword(this.state.email, this.state.password).then(() => {
      console.log('登入完成')
      var user = firebase.auth().currentUser;
       if (user) {
         browserHistory.push('/Dashboard')
       } else {
         browserHistory.push('/')
       }
    }).catch((error) => {
        var errorCode = error.code;
        var errorMessage = error.message;
        console.log(errorCode + errorMessage)
      });
    event.preventDefault()
  }

  render() {
    return (
      <div className="container-fluid">
       <div style={Jeyu.banner}>
        <form onSubmit={this.handleSubmit} style={Jeyu.form} className="loginForm">
         <div style={Jeyu.labelBox}>
          <label htmlFor="email" style={Jeyu.label}>email:</label>
          <input type="email" id="email" value={this.state.email} onChange={this.handleChangeEmail} style={Jeyu.input} />
         </div>
         <div style={Jeyu.labelBox}>
          <label htmlFor="password" style={Jeyu.label}>password:</label>
          <input type="password" id="password" value={this.state.password} onChange={this.handleChangePassword} style={Jeyu.input} />
         </div>
         <input type="submit" value="Submit" style={Jeyu.btn} />
        </form>
       </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Login.js